// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__1Fzkr","placeholder":"List_placeholder__15n55","placeholder-item":"List_placeholder-item__kG8so"};